var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-56.5%",
    y: "-32.3%",
    width: "213%",
    height: "190.4%",
    filterUnits: "objectBoundingBox",
    id: "yq6qg2iuba"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.00392156863 0 0 0 0.0687588778 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-32.4%",
    y: "-48.9%",
    width: "164.8%",
    height: "237%",
    filterUnits: "objectBoundingBox",
    id: "tnuchu5vec"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.00392156863 0 0 0 0.0687588778 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.768 0c3.407 0 6.194 3.406 6.194 7.742 0 4.335-2.787 7.742-6.194 7.742-3.406 0-6.193-3.407-6.193-7.742C4.575 3.406 7.362 0 10.768 0z",
    id: "urizt3nxcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.988 24c-2.632 2.323-6.349 3.871-10.22 3.871-3.87 0-7.587-1.548-10.219-3.871-.62-.62-.774-1.548-.155-2.168 1.704-2.013 4.026-3.406 6.504-4.18 1.238.619 2.477.929 3.87.929 1.394 0 2.633-.31 3.871-.93 2.633.775 4.8 2.168 6.504 4.181.619.62.619 1.549-.155 2.168z",
    id: "1nsmt2p9ld"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.845 2.774)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#yq6qg2iuba)",
    xlinkHref: "#urizt3nxcb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#urizt3nxcb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.845 2.774)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tnuchu5vec)",
    xlinkHref: "#1nsmt2p9ld"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#1nsmt2p9ld"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.02710ff7a3bda8a656618a2d77598294.svg";
export { ForwardRef as ReactComponent };